import * as Yup from 'yup';

const genericCheckboxSchema = Yup.object().test(
  'atLeastOneRequired',
  'Please choose at least one option to\u00A0continue.',
  (value) => {
    if (!value) {
      return false;
    }
    return Object.values(value).some((v) => v !== false);
  }
);

export { genericCheckboxSchema };
